import { LeftOutline } from "antd-mobile-icons";
import type { CSSProperties, FC } from "react";
import { useBackNavigation } from "../../hooks/useBackNavigation";

interface AssessmentHeaderProps {
  step?: number;
  totalSteps?: number;
  onBack?: () => void;
  fallbackRoute?: string;
  className?: string;
  style?: CSSProperties;
  showBackButton?: boolean;
}

const AssessmentHeader: FC<AssessmentHeaderProps> = ({
  step = 1,
  totalSteps = 12,
  onBack,
  fallbackRoute,
  className = "",
  style = {},
  showBackButton = false, // Changed default to false to hide back button
}) => {
  const { goBack } = useBackNavigation();
  return (
    <div
      className={`relative flex w-full items-center px-4 pb-4 pt-8 ${className}`}
      style={style}
    >
      {showBackButton && (
        <button
          className="absolute left-2 top-1 flex h-10 w-10 items-center justify-center rounded-full bg-[#232321]"
          style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
          onClick={() => {
            if (onBack) {
              onBack();
            } else {
              goBack(fallbackRoute);
            }
          }}
        >
          <LeftOutline style={{ fontSize: "var(--font-size-2xl)", color: "#fff" }} />
        </button>
      )}

      <div className="flex w-full justify-center">
        <span className="mx-2 text-title2 font-bold text-white md:text-title1">
          Assessment
        </span>
      </div>

        <span className="absolute right-2 top-2 rounded-full bg-[#22360B] px-3 py-1 text-caption1 font-bold text-[#B9E684]">
        {step} of {totalSteps}
      </span>
    </div>
  );
};

export default AssessmentHeader;
